import { isIOS } from 'react-device-detect';

const isSsr = (): boolean => typeof window === 'undefined';

let CommonData = {};
let VirCommonData = {};
let isInitialCommonData = true;
if (typeof window !== 'undefined' && !window.dataLayer && !isSsr()) {
  window.dataLayer = [];
}
// // 초기화 함수
function dataLayerUndefined() {
  const GTMSET: any = {};
  for (const value of window.dataLayer) {
    for (const key in value) {
      if (
        key.includes('ep_') ||
        key.includes('cm_') ||
        key.includes('ecommerce') ||
        key.includes('event_name')
      ) {
        GTMSET[key] = undefined;
      }
    }
  }
  return window.dataLayer.push(GTMSET);
}

const convertElement = (removeValue: any) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-new-object
  let return_Value = new Object();
  for (const key in removeValue) {
    if (
      removeValue[key] === '' ||
      removeValue[key] === undefined ||
      removeValue[key] === null
    ) {
      // eslint-disable-next-line no-param-reassign
      delete removeValue[key];
    }
  }
  return_Value = removeValue;
  return return_Value;
};

// 하이브리드 코드
const hybrid = (gaData: any) => {
  let emptyObject = JSON.parse(JSON.stringify(convertElement(CommonData)));
  emptyObject = Object.assign(emptyObject, convertElement(gaData));
  if (isIOS) {
    window.webkit.messageHandlers.wconceptgascriptCallbackHandler.postMessage(
      JSON.stringify(emptyObject)
    );
  } else {
    window.wconceptgascriptAndroid.GA_DATA(JSON.stringify(emptyObject));
  }
};

// 가상페이지 전용 하이브리드 코드
const virHybrid = (gaData: any) => {
  let emptyObject = JSON.parse(JSON.stringify(convertElement(VirCommonData)));
  emptyObject = Object.assign(emptyObject, convertElement(gaData));
  if (isIOS) {
    window.webkit.messageHandlers.wconceptgascriptCallbackHandler.postMessage(
      JSON.stringify(emptyObject)
    );
  } else {
    window.wconceptgascriptAndroid.GA_DATA(JSON.stringify(emptyObject));
  }
};

// 공통 화면 함수
const gaScreen = (isNativeAppBoth: boolean, object: any) => {
  try {
    CommonData = object;
    if (isNativeAppBoth) {
      CommonData = { ...CommonData, type: 'P' };
      hybrid(CommonData);
    } else {
      window.dataLayer.push(CommonData);
    }
  } catch (e) {
    console.log('gaScreen 함수 ERROR');
  }
};

// 가상 페이지뷰 함수
const gaVirtualPageView = (
  isNativeAppBoth: boolean,
  object: any,
  isInitial = true
) => {
  try {
    if (!isInitial) {
      isInitialCommonData = false;
    } else {
      VirCommonData = {};
    }
    VirCommonData = object;
    if (isNativeAppBoth) {
      VirCommonData = { ...VirCommonData, type: 'P' };
      virHybrid(VirCommonData);
    } else {
      VirCommonData = { ...VirCommonData, event: 'ga_virtual' };
      window.dataLayer.push(VirCommonData);
      dataLayerUndefined();
    }
    if (isInitialCommonData) {
      VirCommonData = {};
    }
  } catch (e) {
    console.log('gaVirtualPageView 함수 ERROR');
  }
};
// 공통 이벤트 함수 - 객체 방식
const gaEvent = (isNativeAppBoth: boolean, object: any) => {
  try {
    const GAData = object;
    if (isNativeAppBoth) {
      GAData.type = 'E';
      hybrid(GAData);
    } else {
      console.log(object);
      GAData.event = 'ga_event';
      window.dataLayer.push(GAData);
      dataLayerUndefined();
      console.log(GAData);
    }
  } catch (e) {
    console.log('gaEvent 함수 ERROR');
  }
};

// 가상 페이지 이벤트 함수
const gaVirtualEvent = (isNativeAppBoth: boolean, object: any) => {
  try {
    if (!isInitialCommonData) {
      isInitialCommonData = false;
    } else {
      VirCommonData = {};
    }
    // pageview VirCommonData가 이벤트 전용 ep_page_* 값을 덮어쓰는 케이스 보정
    const eventPayload = { ...object };
    let GAData = Object.assign(object, VirCommonData);
    if (object.event_name === 'subgnb_view') {
      GAData = { ...GAData, ...eventPayload };
    }
    if (isNativeAppBoth) {
      GAData.type = 'E';
      virHybrid(GAData);
    } else {
      GAData.event = 'ga_virevent';
      window.dataLayer.push(GAData);
      dataLayerUndefined();
    }
  } catch (e) {
    console.log('gaVirtualEvent 함수 ERROR');
  }
};

// 공통 전자상거래 함수
const ecommerceSet = (
  isNativeAppBoth: boolean,
  E_step: any,
  items: any,
  actionList: any,
  addDimension: any,
  addMetric: any
) => {
  try {
    if (isNativeAppBoth) {
      let APPData = {};
      APPData = { ...APPData, event_name: E_step, type: 'E' };
      if (items.length > 0) {
        APPData = { ...APPData, items };
      }
      APPData = { ...APPData, transaction: actionList };
      APPData = Object.assign(APPData, addDimension, addMetric);
      hybrid(APPData);
    } else {
      let Ecommerce = {};
      let DataSend = {};
      if (items.length > 0) {
        Ecommerce = { items: [] };
        Ecommerce = { ...Ecommerce, items };
      }
      const EcommerceData = { ...Ecommerce, ...actionList };
      DataSend = { ...addDimension, ...addMetric };
      DataSend = {
        ...DataSend,
        event: 'ga_virecommerce',
        event_name: E_step,
        ecommerce: EcommerceData,
      };
      window.dataLayer.push(DataSend);
      dataLayerUndefined();
    }
  } catch (e) {
    console.log('EcommerceSet 함수 ERROR');
  }
};

const virEcommerceSet = (
  isNativeAppBoth: boolean,
  E_step: any,
  items: any,
  actionList: any,
  addDimension: any,
  addMetric: any
) => {
  try {
    if (isNativeAppBoth) {
      let APPData = {};
      APPData = { ...APPData, event_name: E_step, type: 'E' };
      if (items && items?.length > 0) {
        APPData = { ...APPData, items };
      }
      APPData = { ...APPData, transaction: actionList };
      APPData = Object.assign(APPData, addDimension, addMetric);
      virHybrid(APPData);
    } else {
      let Ecommerce = {};
      let DataSend = {};
      if (items && items.length > 0) {
        Ecommerce = { items: [] };
        Ecommerce = { ...Ecommerce, items };
      }
      const EcommerceData = { ...Ecommerce, ...actionList };
      DataSend = { ...addDimension, ...addMetric };
      DataSend = {
        ...DataSend,
        event: 'ga_virecommerce',
        event_name: E_step,
        ecommerce: EcommerceData,
      };
      if (!isInitialCommonData) {
        DataSend = {
          ...VirCommonData,
          ...DataSend,
        };
      }
      window.dataLayer.push(DataSend);
      dataLayerUndefined();
    }
  } catch (e) {
    console.log('virEcommerceSet 함수 ERROR');
  }
};

export {
  gaScreen,
  gaEvent,
  gaVirtualPageView,
  gaVirtualEvent,
  ecommerceSet,
  virEcommerceSet,
};
